
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundUnavailableFill as ObiSoundUnavailableFillElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-unavailable-fill.js';
 
 
 

 
 export const ObiSoundUnavailableFill = createComponent({
   react: React,
   tagName: 'obi-sound-unavailable-fill',
   elementClass: ObiSoundUnavailableFillElement,
   events: {
     
   }
  });
 
 